<template>
    <section class="app-main" :style="[hiddenSidebarStyle]">
        <transition
                mode="out-in"
                enter-active-class="fadeIn"
                leave-active-class="fadeOut"
                appear>
            <router-view class="animated"></router-view>
        </transition>
    </section>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        sidebar: 'sidebar'
      }),
      hiddenSidebarStyle () {
        return this.sidebar.hidden ? {'margin-left': 0} : null
      }
    },

    components: {}
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/layout/AppMain.vue